import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeIndices: [],
  alarmId: null,
  confirmModal: false,
  days: [],
  editCalendar: false,
  endTime: '',
  isLoading: false,
  open: false,
  openDeleteModal: false,
  powerValue: '',
  startTime: '',
  isOperativeMode: false,
};
const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    resetState() {
      return { ...initialState };
    },
    setActiveIndices(state, action) {
      state.activeIndices = action.payload;
    },
    setAlarmId(state, action) {
      state.alarmId = action.payload;
    },
    setConfirmModal(state, action) {
      state.confirmModal = action.payload;
    },
    setDays(state, action) {
      const sortedDays = action.payload?.slice().sort((a, b) => b.val - a.val);
      state.days = sortedDays;
    },
    setEndTime(state, action) {
      state.endTime = action.payload;
    },
    setStartTime(state, action) {
      state.startTime = action.payload;
    },
    openModal: (state, action) => {
      state.open = true;
      state.editCalendar = true;
      state.alarmId = action.payload;
    },
    setOpen(state, action) {
      state.open = action.payload;
    },
    setOpenDeleteModal(state, action) {
      state.openDeleteModal = action.payload;
    },
    setIsOperativeMode(state, action) {
      state.isOperativeMode = action.payload;
    },
    setEditCalendar(state, action) {
      state.editCalendar = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setTimes(state, action) {
      state.startTime = action.payload.start;
      state.endTime = action.payload.end;
    },
    toggleModals: (state, action) => {
      state.open = action.payload.open;
      state.openDeleteModal = action.payload.openDeleteModal;
    },
    cancelAlarm: (state, action) => {
      state.openDeleteModal = false;
      state.confirmModal = true;
      state.activeIndices = action.payload.initialState;
    },
    setModalAndTimes(state, action) {
      state.open = action.payload.open;
      state.startTime = action.payload.start;
      state.endTime = action.payload.end;
    },
    setPower(state, action) {
      state.powerValue = action.payload;
    },
  },
});

export const CalendarActions = calendarSlice.actions;

export default calendarSlice;
